<template>
    <section v-if="content" class="c-o-section-statistics">
        <h4 v-if="data && data.message">{{data.message}}</h4>
        <div v-else class="c-o-section-statistics__inner">
            <div class="c-o-section-statistics__blocks">
                <div v-for="(stat, index) in stats" class="c-o-section-statistics__block" :key="`stat-block-${index}`">
                    <p class="c-o-section-statistics__number">{{stat.number | numberWithSpaces}}</p>
                    <p class="c-o-section-statistics__description">{{stat.description}}</p>
                </div>
            </div>
            <p class="c-o-section-statistics__blurb">{{blurb}}</p>
        </div>
    </section>
</template>

<script>
    import filters from '../../../../filters/index.js'

    export default {
        filters: filters,
        props:['content', 'data'],
        computed:{
            stats:{
                get(){
                    const requests = this.content.request_count;
                    const companies = this.content.companies_count;
                    const ratings = this.content.ratings_count;
                    
                    return [
                        {
                            number: requests,
                            description: this.content.request_text,
                        },
                        {
                            number: companies,
                            description: this.content.companies_text,
                        },
                        {
                            number: ratings,
                            description: this.content.ratings_text,
                        },
                    ];
                }
            },
            blurb: {
                get(){
                    return this.content.subtitle;
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/page-sections/OrganismSectionStatistics.vue